(() => {
  const listenerKey = Symbol.for("astrowelt.tarotDailyDraw")
  if (document[listenerKey]) return
  document[listenerKey] = true
  const apps = new WeakMap()

  function start() {
    document.querySelectorAll("[data-tarot-daily-draw]").forEach((root) => {
      if (apps.has(root)) return
      root.dataset.initialized = "true"

      const cards = JSON.parse(root.dataset.cards)
      const card = root.querySelector("[data-card]")
      const image = root.querySelector("[data-card-image]")
      const draw = root.querySelector("[data-draw]")
      const reset = root.querySelector("[data-reset]")
      const result = root.querySelector("[data-result]")
      const name = root.querySelector("[data-card-name]")
      const meaning = root.querySelector("[data-card-meaning]")
      const link = root.querySelector("[data-card-link]")
      const status = root.querySelector("[data-status]")
      let busy = false
      let revealed = false
      let activeLoader = null
      let loadTimeout = null
      let drawSequence = 0
      const animationTimers = new Set()

      function later(callback, delay) {
        const timer = setTimeout(() => {
          animationTimers.delete(timer)
          callback()
        }, delay)
        animationTimers.add(timer)
      }

      function cancelAnimationTimers() {
        animationTimers.forEach(clearTimeout)
        animationTimers.clear()
      }

      function resetState() {
        drawSequence += 1
        if (activeLoader) activeLoader.onload = activeLoader.onerror = null
        clearTimeout(loadTimeout)
        cancelAnimationTimers()
        activeLoader = null
        busy = false
        revealed = false
        card.classList.remove("flipped", "shuffling", "revealing")
        result.hidden = true
        result.classList.remove("fade-in")
        reset.hidden = true
        draw.hidden = false
        draw.disabled = false
        status.textContent = ""
      }
      apps.set(root, {reset: resetState})

      draw.addEventListener("click", () => {
        if (busy || revealed || !cards.length) return
        busy = true
        draw.disabled = true
        status.textContent = "Ihre Karte wird gezogen …"
        const sequence = ++drawSequence
        const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)").matches
        let shuffleFinished = reducedMotion
        let imageLoaded = false
        if (!reducedMotion) card.classList.add("shuffling")
        const selected = cards[Math.floor(Math.random() * cards.length)]
        const loader = new Image()
        activeLoader = loader
        loadTimeout = setTimeout(failed, 15000)

        function failed() {
          clearTimeout(loadTimeout)
          cancelAnimationTimers()
          loader.onload = loader.onerror = null
          activeLoader = null
          card.classList.remove("shuffling")
          busy = false
          draw.disabled = false
          status.textContent = "Die Karte konnte nicht geladen werden. Bitte versuchen Sie es erneut."
        }

        function reveal() {
          if (!shuffleFinished || !imageLoaded || sequence !== drawSequence || !root.isConnected) return
          image.src = selected.image
          image.alt = selected.name
          name.textContent = selected.name
          meaning.textContent = selected.meaning
          link.href = selected.url
          card.classList.remove("shuffling")
          // Commit the resting transform before starting the flip transition.
          if (!reducedMotion) card.getBoundingClientRect()
          card.classList.add("flipped")
          if (!reducedMotion) card.classList.add("revealing")

          const finish = () => {
            if (sequence !== drawSequence || !root.isConnected) return
            card.classList.remove("revealing")
            revealed = true
            busy = false
            draw.hidden = true
            reset.hidden = false
            result.hidden = false
            result.classList.toggle("fade-in", !reducedMotion)
            status.textContent = ""
            name.focus({preventScroll: true})
          }
          if (reducedMotion) finish()
          else later(finish, 600)
        }

        if (!reducedMotion) {
          later(() => {
            shuffleFinished = true
            reveal()
          }, 800)
        }
        loader.onerror = failed
        loader.onload = () => {
          clearTimeout(loadTimeout)
          loader.onload = loader.onerror = null
          activeLoader = null
          imageLoaded = true
          reveal()
        }
        loader.src = selected.image
      })

      reset.addEventListener("click", () => {
        if (busy) return
        resetState()
        status.textContent = "Die Karten sind bereit für eine neue Ziehung."
        draw.focus({preventScroll: true})
      })
    })
  }

  document.addEventListener("turbo:load", start)
  document.addEventListener("turbo:before-cache", () => {
    document.querySelectorAll("[data-tarot-daily-draw]").forEach((root) => {
      // Reset both the current app state and the markup copied into Turbo's cache.
      apps.get(root)?.reset()
      delete root.dataset.initialized
    })
  })
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start, {once: true})
  else start()
})()
